
const Images = require.context("../../assets/configuration", false);
import Configuration from "@/assets/configuration/app.config"
// Dependencies
import { DocumentTemplate } from "@/assets/scripts/Application";
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'SplashMenu',
  props: {
    templates: {
      type: Array as PropType<Array<DocumentTemplate>>,
      required: true
    }
  },
  data() {
    let organization;
    if(Configuration.branding.organization) {
      organization = Images(Configuration.branding.organization); 
    }
    return {
      product: Images(Configuration.branding.product),
      organization
    }
  },
  emits: ["new", "open"]
});
